import React, { useEffect, useRef, useState } from 'react';
import MutiSelectDropDown from "../../Components/ModalPopup/FormModules/MutiSelectDropDown";
import { Helpers } from '../../Helpers';
import { Overlay, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { Utils } from '../../Utils';
import { useDispatch, useSelector } from 'react-redux';
import { FaPencilAlt } from "react-icons/fa";
import EditIconButton from '../ModalPopup/Popover/EditIconButton';
import { FaPercentage } from "react-icons/fa";
import DiscountPopover from '../ModalPopup/Popover/discountPopover';
import TaxPopover from '../ModalPopup/Popover/taxPopover';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { getIndustrySuggestionStart, getJobTitleSuggestionStart } from '../../Store/Slices/scrapperSlice';

const animatedComponents = makeAnimated();
const SubformInputs = ({ item, error, handleInputChange, handleBlur, labelValue,
  users, preview = false, lookupData = null, currentCurrencyData, rowData,
  sectionData, rowIndex, rowDiscount, handleRowDiscount, updateRowDicount, rowTax, handleRowTax,
  input_type, field_label, isOverallTax, showFrom, jobSuggestionData }) => {

  let currentOrg = useSelector((state) => state?.org);
  let [extra_fields] = useState(item?.extra_fields || {});
  let [fieldLabel] = useState(extra_fields?.field_label || '');
  let [lookupDatas, setLookupDatas] = useState([]);
  let [maxLength] = useState(extra_fields?.number_of_characters_allowed || undefined);
  let [showTooltip] = useState(extra_fields?.show_tooltip || null);
  let [isShowIconHoverTooltip] = useState(showTooltip?.checked && showTooltip?.type === 'info' && showTooltip?.message?.length > 0);
  let [isShowInputHoverTooltip] = useState(showTooltip?.checked && showTooltip?.type === 'static' && showTooltip?.message?.length > 0);
  let [discountPopoverOpen, setDiscountPopoverOpen] = useState(false);
  let [taxPopoverOpen, setTaxPopoverOpen] = useState(false);

  useEffect(() => {
    if (lookupData?.hasOwnProperty(fieldLabel) && !preview) {
      let list = lookupData[fieldLabel];
      let data = [];
      if (list?.length > 0) {
        for (let x of list) {
          if (x?.data?.length > 0) {
            for (let y of x?.data) {
              let title = extra_fields?.related_list_title?.trim();
              let possibleKeys = [Helpers.replaceData(title), Helpers.replaceData(title + "_")];
              for (let key of possibleKeys) {
                if (y?.section_data?.hasOwnProperty(key) && typeof y.section_data[key] === "string" && y.section_data[key]?.length > 0) {
                  data.push(y.section_data[key]);
                  break;
                }
              }
            }
          }
        }
      }
      setLookupDatas(data);
    } else {
      setLookupDatas([]);
    }
  }, [lookupData]);

  const [showPopover, setShowPopover] = useState(false);
  const targetRef = useRef(null);

  const handleEditClick = () => {
    setShowPopover(!showPopover);
  };

  const handleClose = () => {
    setShowPopover(false);
  };

  const handleSubmit = (type, value) => {
    setShowPopover(false);
    handleRowDiscount(rowIndex, type, value, input_type, field_label)
    setDiscountPopoverOpen(false);
  }

  // for tax
  const [showTaxPopover, setShowTaxPopover] = useState(false);
  const targetTaxRef = useRef(null);

  const handleTaxEditClick = () => {
    setShowTaxPopover(!showTaxPopover);
  };

  const handleTaxClose = () => {
    setShowTaxPopover(false);
  };

  const handleTaxSubmit = (type) => {
    setShowTaxPopover(false);
    handleRowTax(rowIndex, type)
    setTaxPopoverOpen(false);
  }

  const formatNumber = (amount) => {
    return new Intl.NumberFormat(currentCurrencyData?.digit_format, {
      style: "decimal",
      minimumFractionDigits: currentCurrencyData?.decimal_place,
      maximumFractionDigits: currentCurrencyData?.decimal_place,
    }).format(amount);
  };

  const handleDiscountChange = (value, index) => {
    updateRowDicount({ index: index, value })
  }
  // console.log('item:', item)

  // job titles dropdown data
  const dispatch = useDispatch();
  // let scrapperData = useSelector((state) => state.scrapper);
  // // console.log('scrapper data???', scrapperData)
  // let jobSuggestionData = scrapperData?.jobSuggestionData;
  // console.log('jobSuggestionData:', jobSuggestionData);
  let [jobTitleData, setJobTitleData] = useState([]);

  let [filterObj, setFilterObj] = useState({
    "contact_email_status_v2": [],
    "fields": ["email", "first_name", "last_name", "phone_numbers"],
    "q_keywords": "",
    "person_titles": [],
    "organization_domains": [],
    "person_locations": [],
    "include_similar_titles": true,
    "organization_ids": [],
    "keywords": [],
    "organization_num_employees_ranges": [],
    "name_search": ""
  })

  // useEffect(() => {
  //   dispatch(getJobTitleSuggestionStart({ search: "", count: 10 }))
  //   // dispatch(getIndustrySuggestionStart({ search: "", count: 10 }))
  // }, [])

  useEffect(() => {
    if (jobSuggestionData?.length) {
      setJobTitleData(jobSuggestionData?.map((data) =>
        ({ value: data?.job_title, label: data?.job_title })
      ))
    }
  }, [jobSuggestionData])

  const handleJobTitle = (e) => {
    setFilterObj(prev => ({
      ...prev,
      person_titles: e
    }));
  }

  const handleJobTitleInput = (e) => {
    if (e.trim().length === 0) return;
    dispatch(getJobTitleSuggestionStart({ search: e, count: 10 }))
  }

  let selectedOption = jobTitleData.find((opt) => opt.label === labelValue) || null;

  if (!selectedOption && labelValue) {
    const newOption = {
      value: labelValue,
      label: labelValue
    };
    setJobTitleData((prev) => [...prev, newOption]);
    selectedOption = newOption;
  }

  return (
    <>
      <div className="form-group">
        {/* <div className={`col-auto input-control`} style={{ minWidth: item?.extra_fields?.width ? `${item?.extra_fields?.width}px` : ""}}> */}
        {/* col-auto remvoved to fix table's one coumn input field ui overlap with next
                                                        column input field ui issue */}
        <div className={`input-control`} style={{ minWidth: (fieldLabel !== 'Product Name' && fieldLabel !== 'Tax' && fieldLabel !== 'Discount') && '140px' }}>
          <OverlayTrigger placement="bottom-start" overlay={
            <Tooltip id={`tooltip-${item?.id}`}>
              {showTooltip?.message || ""}
            </Tooltip>
          } {...(isShowInputHoverTooltip ? {} : { show: false })}>
            <div className={`${isShowIconHoverTooltip ? 'input-group' : 'none-input-group'}`}>
              {item?.input_type === "text" && (
                <input
                  type="text"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  maxLength={maxLength}
                  required={item?.extra_fields?.required}
                  placeholder={fieldLabel || ""}
                />
              )}
              {item?.input_type === "email" && (
                <input
                  type="email"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  required={item?.extra_fields?.required}
                />
              )}
              {item?.input_type === "number" && (
                <input
                  type="number"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  maxLength={maxLength}
                  required={item?.extra_fields?.required}
                  onBlur={handleBlur}
                />
              )}

              {item?.input_type === "percent" && (
                <input
                  type="number"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  maxLength={maxLength}
                  required={item?.extra_fields?.required}
                />
              )}

              {item?.input_type === "auto_number" && (
                <input
                  type="text"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  value={`${item?.extra_fields?.prefix || ""}${item?.extra_fields?.startingNumber || ""}${item?.extra_fields?.suffix || ""}`}
                  onChange={handleInputChange}
                  maxLength={maxLength}
                  required={item?.extra_fields?.required}
                />
              )}
              {item?.input_type === "decimal" && (
                <input
                  type="text"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  maxLength={maxLength}
                  required={item?.extra_fields?.required}
                  step="any"
                  onBlur={handleBlur}
                />
              )}

              {item?.input_type === "longinteger" && (
                <input
                  type="text"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  maxLength={maxLength}
                  required={item?.extra_fields?.required}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
              )}
              {item?.input_type === 'password' && (
                <input type="password" className={`form-control ${error ? 'is-invalid' : ''}`} id={item?.id} placeholder={fieldLabel || ""} onChange={handleInputChange} value={labelValue} required={item?.extra_fields?.required} maxLength={maxLength} />
              )}
              {item?.input_type === "checkbox" && (
                <input
                  className={`form-check-input mt-2 border-dark-subtle ${error ? "is-invalid" : ""}`}
                  type="checkbox"
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  checked={extra_fields?.checked || labelValue === "X"}
                  required={extra_fields?.required}
                />
              )}
              {item?.input_type === 'radio' && (
                <div className={`form-check ${error ? 'is-invalid' : ''}`}>
                  <input type="radio" className="form-check-input mt-2" id={item?.id} name={item?.extra_fields?.name} onChange={handleInputChange} checked={labelValue === 'X'} />
                </div>
              )}
              {item?.input_type === 'textarea' && (
                <textarea className={`form-control ${error ? 'is-invalid' : ''}`} id={item?.id} rows="3" placeholder={fieldLabel || ""} onChange={handleInputChange} value={labelValue} required={item?.extra_fields?.required} maxLength={maxLength}></textarea>
              )}
              {item?.input_type === "select" && (
                item?.extra_fields?.field_label === "Job Title" ?
                  <>
                    <Select
                      // components={animatedComponents}
                      // closeMenuOnSelect={true}
                      // isMulti={false}
                      options={jobTitleData}
                      // className="basic-multi-select"
                      // onChange={handleJobTitle}
                      onInputChange={handleJobTitleInput}
                      // onCreateOption={handleCreate}
                      // value={filterObj.person_titles}
                      placeholder="Job Titles"
                      // className={`form-select ${error ? "is-invalid" : ""}`}
                      // id={item?.id}
                      // value={labelValue}
                      value={selectedOption}
                      // value={jobTitleData.find(opt => opt.value === labelValue) || null}
                      onChange={handleInputChange}
                      isClearable
                    />
                    {/* <select
                      className={`form-select ${error ? "is-invalid" : ""}`}
                      id={item?.id}
                      value={labelValue}
                      onChange={handleInputChange}
                    >
                      <option value="">Select 123</option>
                      {item?.extra_fields?.options?.map((option, index) => (
                        <option value={option} key={`${index}`}>
                          {option}
                        </option>
                      ))}
                    </select> */}
                  </>
                  :
                  <>
                    <select
                      className={`form-select ${error ? "is-invalid" : ""}`}
                      id={item?.id}
                      value={labelValue}
                      onChange={handleInputChange}
                    >
                      <option value="">Select</option>
                      {item?.extra_fields?.options?.map((option, index) => (
                        <option value={option} key={`${index}`}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </>
              )}
              {item?.input_type === "lookup" && (
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="fa fa-search position-relative z-index-3"></i>
                  </span>
                  <select
                    className={`form-select ${error ? "is-invalid" : ""}`}
                    id={item?.id}
                    placeholder={fieldLabel || ""}
                    value={labelValue || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    {lookupDatas?.map((option, index) => (
                      <option value={option} key={`${index}`}>
                        {option}
                      </option>
                    ))}
                  </select>
                  {isShowIconHoverTooltip && (
                    <span className="input-group-text">
                      <OverlayTrigger placement="bottom" overlay={<Tooltip className="position-absolute" id={`tooltip-${item?.id}`}>{showTooltip?.message}</Tooltip>}>
                        <div style={{ display: 'inline-block' }}>
                          <i className="fa-regular fa-circle-question"></i>
                        </div>
                      </OverlayTrigger>
                    </span>
                  )}
                </div>
              )}
              {item?.input_type === "multi-select" && (
                <div className={`multi-select ${error ? "is-invalid" : ""}`}>
                  <MutiSelectDropDown
                    preview={preview}
                    options={extra_fields?.options}
                    handleInputChange={handleInputChange}
                    default_value={labelValue}
                  />
                </div>
              )}
              {(item?.input_type === 'multi-lookup') && (
                <div className={`multi-select ${error ? 'is-invalid' : ''}`}>
                  <MutiSelectDropDown preview={preview} options={lookupDatas?.map(x => ({ name: x }))} handleInputChange={handleInputChange} default_value={labelValue} />
                </div>
              )}
              {item?.input_type === "currency" && (
                <div>
                  <div className="input-group mt-0">
                    {/* <span className={`input-group-text bg-white ${extra_fields?.required ? "unique" : ""}`}>{Utils.currencySymbols(currentOrg?.homeCurrencies?.currency_code || "")}</span> */}
                    {/* {fieldLabel === 'Discount' &&
                      <span className={`input-group-text bg-white fs-12 fw-semibold ${extra_fields?.required ? "unique" : ""}`}>{rowDiscount[rowIndex]?.discount_type === 'amount' ? (currentCurrencyData?.currency_code || "") : <FaPercentage />}</span>
                    } */}
                    {fieldLabel === 'Tax' ?
                      <>
                        <span className={`input-group-text bg-white fs-12 fw-semibold ${extra_fields?.required ? "unique" : ""} ${isOverallTax && 'linetax'}`}><FaPercentage /></span>
                        <input
                          type="text"
                          className="form-control border-start-0"
                          aria-label="Amount (to the nearest dollar)"
                          id={item?.id}
                          placeholder={fieldLabel || ""}
                          onChange={handleInputChange}
                          value={labelValue || ""}
                          maxLength={maxLength}
                          required={item?.extra_fields?.required}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9\.]/g, "");
                          }}
                          onBlur={handleBlur}
                          disabled={isOverallTax ? true : false}
                          style={{ width: `${Math.max(labelValue.length, 1)}ch` }}
                        />
                        <span className={`input-group-text bg-white fs-12 fw-semibold linetax ${extra_fields?.required ? "unique" : ""}`}>{currentCurrencyData?.currency_code || ""}</span>
                        <input
                          type="text"
                          className="form-control border-start-0"
                          value={formatNumber(rowTax?.[rowIndex]?.tax_amount)}
                          disabled
                          style={{ width: `${Math.max(formatNumber(rowTax?.[rowIndex]?.tax_amount).length, 1)}ch` }} />
                      </>

                      : (fieldLabel === 'Discount') ?
                        <>
                          <input
                            type="text"
                            className="form-control border-start-0"
                            aria-label="Amount (to the nearest dollar)"
                            id={item?.id}
                            placeholder={fieldLabel || ""}
                            onChange={handleInputChange}
                            value={labelValue || ""}
                            maxLength={maxLength}
                            required={item?.extra_fields?.required}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9\.]/g, "");
                            }}
                            onBlur={handleBlur}
                          />
                          <select className="form-select"
                            value={rowDiscount?.[rowIndex]?.discount_type}
                            onChange={(e) => handleDiscountChange(e.target.value, rowIndex)}>
                            <option value="percentage">%</option>
                            <option value="amount">{currentCurrencyData?.currency_code || 'Amount'}</option>
                          </select>
                          {rowDiscount?.[rowIndex]?.discount_type === 'percentage' &&
                            <>
                              {/* <span className={`input-group-text bg-white fs-12 fw-semibold linetax ${extra_fields?.required ? "unique" : ""}`}>{currentCurrencyData?.currency_code || ""}</span> */}
                              <input
                                type="text"
                                className="form-control border-start-0"
                                value={formatNumber(rowDiscount?.[rowIndex]?.discount_amount)}
                                disabled
                                style={{ width: `${Math.max(formatNumber(rowTax?.[rowIndex]?.tax_amount).length + 2, 1)}ch` }} />
                            </>
                          }
                        </>
                        : <input
                          type="text"
                          className="form-control"
                          aria-label="Amount (to the nearest dollar)"
                          id={item?.id}
                          placeholder={fieldLabel || ""}
                          onChange={handleInputChange}
                          value={labelValue || ""}
                          maxLength={maxLength}
                          required={item?.extra_fields?.required}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9\.]/g, "");
                          }}
                          onBlur={handleBlur}
                        // onClick={() => {
                        //   if (fieldLabel === 'Discount') {
                        //     setDiscountPopoverOpen(true);
                        //   }
                        // }}
                        />
                    }

                    {/* {(showFrom !== 'Preview' && fieldLabel === 'Discount') &&
                    <span className={`input-group-text bg-white fs-12 fw-semibold`}>
                      <EditIconButton onClick={handleEditClick} targetRef={targetRef} />
                      <Overlay
                        show={showPopover}
                        target={targetRef.current}
                        placement="right"
                        containerPadding={10}
                        rootClose
                        onHide={handleClose}
                      >
                        <Popover id="edit-popover">
                          <Popover.Header as="h3">Set Discount</Popover.Header>
                          <Popover.Body>
                            <DiscountPopover onSubmit={handleSubmit} onCancel={handleClose} discountRow={rowDiscount[rowIndex]} />
                          </Popover.Body>
                        </Popover>
                      </Overlay>
                    </span>
                  }

                  {!isOverallTax &&
                    <>
                      {(showFrom !== 'Preview' && fieldLabel === 'Tax') &&
                        <span className={`input-group-text bg-white fs-12 fw-semibold`}>
                            <EditIconButton onClick={handleTaxEditClick} targetRef={targetTaxRef} />
                            <Overlay
                              show={showTaxPopover}
                              target={targetTaxRef.current}
                              placement="right"
                              containerPadding={10}
                              rootClose
                              onHide={handleTaxClose}
                            >
                              <Popover id="edit-popover">
                                <Popover.Header as="h3">Set Tax</Popover.Header>
                                <Popover.Body>
                                  <TaxPopover onSubmit={handleTaxSubmit} onCancel={handleTaxClose} taxRow={rowTax[rowIndex]} />
                                </Popover.Body>
                              </Popover>
                            </Overlay>
                          </span>
                        }
                      </>
                    } */}

                    {isShowIconHoverTooltip && (
                      <span className="input-group-text">
                        <OverlayTrigger placement="bottom" overlay={<Tooltip className="position-absolute" id={`tooltip-${item?.id}`}>{showTooltip?.message}</Tooltip>}>
                          <div style={{ display: 'inline-block' }}>
                            <i className="fa-regular fa-circle-question"></i>
                          </div>
                        </OverlayTrigger>
                      </span>
                    )}
                  </div>

                  {fieldLabel === "Discount" && showFrom !== "Preview" && (
                    <div className="mt-2">
                      {discountPopoverOpen && (
                        <DiscountPopover
                          onSubmit={handleSubmit}
                          onCancel={() => setDiscountPopoverOpen(false)}
                          onClose={() => setDiscountPopoverOpen(false)}
                          discountRow={rowDiscount?.[rowIndex]}
                        />
                      )}
                    </div>
                  )}

                  {fieldLabel === "Tax" && !isOverallTax && showFrom !== "Preview" && (
                    <div className="mt-2">
                      {taxPopoverOpen && (
                        <TaxPopover
                          onSubmit={handleTaxSubmit}
                          onCancel={() => setTaxPopoverOpen(false)}
                          taxRow={rowTax[rowIndex]}
                        />
                      )}
                    </div>
                  )}

                </div>
              )}
              {item?.input_type === "date" && (
                <input
                  type="date"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  required={item?.extra_fields?.required}
                />
              )}
              {item?.input_type === "datetime-local" && (
                <input
                  type="datetime-local"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  required={item?.extra_fields?.required}
                />
              )}

              {item?.input_type === "image" && (
                <input
                  type="file"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  required={extra_fields?.required}
                />
              )}
              {item?.input_type === "file" && (
                <input
                  type="file"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  required={extra_fields?.required}
                />
              )}
              {item?.input_type === "url" && (
                <input
                  type="url"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  maxLength={maxLength}
                  required={item?.extra_fields?.required}
                />
              )}
              {item?.input_type === "tel" && (
                <input
                  type="tel"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  id={item?.id}
                  placeholder={fieldLabel || ""}
                  onChange={handleInputChange}
                  value={labelValue || ""}
                  maxLength={maxLength}
                  required={item?.extra_fields?.required}
                />
              )}
              {(item?.input_type === 'user' && extra_fields?.user_type === 'single_user') && (
                <div className={`multi-select ${error ? 'is-invalid' : ''}`}>
                  <label htmlFor={item?.id}>
                    {fieldLabel}
                  </label>
                  <MutiSelectDropDown preview={preview} options={preview ? (Object?.keys(labelValue)?.length > 0 ? [labelValue] : []) : (users || [])} handleInputChange={handleInputChange} default_value={typeof labelValue === "string" ? null : labelValue} singleSelect={true} isSingleUser={true} isUser={true} />
                </div>
              )}
              {(item?.input_type === 'user' && extra_fields?.user_type === 'multiple_user') && (
                <div className={`multi-select ${error ? 'is-invalid' : ''}`}>
                  <label htmlFor={item?.id}>
                    {fieldLabel}
                  </label>
                  <MutiSelectDropDown preview={preview} options={preview ? labelValue || [] : (users || [])} handleInputChange={handleInputChange} default_value={typeof labelValue === "string" ? [] : labelValue} isUser={true} />
                </div>
              )}

              {(isShowIconHoverTooltip && !['currency', 'lookup']?.includes(item?.input_type)) && (
                <span className="input-group-text">
                  <OverlayTrigger placement="bottom" overlay={<Tooltip className="position-absolute" id={`tooltip-${item?.id}`}>{showTooltip?.message}</Tooltip>}>
                    <div style={{ display: 'inline-block' }}>
                      <i className="fa-regular fa-circle-question"></i>
                    </div>
                  </OverlayTrigger>
                </span>
              )}

              {error && <div id={item?.id} placeholder={fieldLabel || ""} className="invalid-feedback">
                {error}
              </div>
              }
            </div>
          </OverlayTrigger>
        </div>
      </div>
    </>
  );
};

export default SubformInputs;
